import { CssBaseline } from '@mui/material'
import { Provider } from 'jotai'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router'

import App from './App'
import DebugBridge from './components/common/DebugBridge'
import LocationBridge from './components/common/LocationBridge'
import MediaQueryBridge from './components/common/MediaQueryBridge'
import { appStore } from './contexts/store'
import Config from './data/Config'
import './index.css'
import { attachAuthInterceptors } from './services/http/attachAuth'
import AppTheme from './theme/AppTheme'

// import reportWebVitals from './reportWebVitals'

const debugBridge = false
// const debugBridge = true

function ThemedApp() {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Router>
        <MediaQueryBridge />
        <LocationBridge />
        {debugBridge && <DebugBridge />}
        <App />
      </Router>
    </AppTheme>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
// React.StrictMode在开发环境下会故意渲染组件两次，以帮助开发者发现副作用问题。这是正常行为，不会影响生产环境。如果你想要避免这种行为，可以在开发环境下暂时移除StrictMode：
// root.render(
//   <React.StrictMode>
//     <ThemedApp />
//   </React.StrictMode>,
// )

attachAuthInterceptors()

root.render(
  <Provider store={appStore}>
    <ThemedApp />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()

let devToolsOpen = false

const funLines = [
  { text: '', style: '' },
  { text: '👋 Hey there, curious Developer!', style: 'color: #00bfff; font-size: 16px; font-weight: bold;' },
  { text: '', style: '' },
  { text: "🧐 Looks like you've popped open DevTools — snooping around, huh?", style: 'color: #1e90ff; font-size: 14px;' },
  { text: '', style: '' },
  { text: '🐞 Spot a bug or glitch? Let us know!', style: 'color: #ff6347; font-size: 14px;' },
  { text: '📬 info@bookingOnSNow.com — we will fix it fast ⚔️', style: 'color: #ffa500; font-size: 14px;' },
  { text: '', style: '' },
  { text: '👨‍💻 Just exploring? Awesome! We love curious devs like you 🙌', style: 'color: #32cd32; font-size: 14px;' },
  { text: '❄️ Crafting a snowy-smooth experience. Your help is welcome!', style: 'color: #00ced1; font-size: 14px;' },
  { text: '', style: '' },
  { text: '🚀 Stay awesome & happy coding!', style: 'color: #ff69b4; font-size: 14px; font-weight: bold;' },
  { text: '', style: '' },
]

const checkDevTools = () => {
  const widthThreshold = window.outerWidth - window.innerWidth > 100
  const heightThreshold = window.outerHeight - window.innerHeight > 100

  if (!devToolsOpen && (widthThreshold || heightThreshold)) {
    devToolsOpen = true // 标记只触发一次
    funLines.forEach((line) => {
      console.log(`%c${line.text}`, line.style)
    })
  } else if (!widthThreshold && !heightThreshold && devToolsOpen) {
    devToolsOpen = false // DevTools 关闭后，重置状态
  }
}

if (Config.IS_PROD) {
  setInterval(checkDevTools, 2000)
}
